<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'AI_ASSISTANT.TESTING.PAGE_TITLE' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'AI_ASSISTANT.TESTING.SELECT_ASSISTANT' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (loading()) {
          <div class="loading-container">
            <glxy-loading-spinner />
          </div>
        } @else {
          <mat-list>
            @if (assistants().length === 0) {
              <mat-list-item>
                <glxy-empty-state>
                  <mat-icon>smart_toy</mat-icon>
                  <p>{{ 'AI_ASSISTANT.TESTING.NO_ASSISTANTS_FOUND' | translate }}</p>
                </glxy-empty-state>
              </mat-list-item>
            } @else {
              @for (assistant of assistants(); track assistant.id) {
                <mat-list-item class="assistant-item" (click)="selectAssistant(assistant)">
                  <div class="assistant">
                    <div class="title">
                      @if (assistant.avatarUrl) {
                        <img class="icon" [src]="assistant.avatarUrl" />
                      } @else {
                        <mat-icon>smart_toy</mat-icon>
                      }
                      <span class="assistant-name">{{ assistant.name }}</span>
                    </div>
                  </div>
                </mat-list-item>
              }
            }
          </mat-list>
        }
      </mat-card-content>
    </mat-card>
  </glxy-page-wrapper>
</glxy-page>
